import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ModuleList() {
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchModules();
  }, []);

  const fetchModules = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/modules`, {
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        setModules(data);
      }
    } catch (error) {
      console.error('Error fetching modules:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusIcon = (status) => {
    if (status === 'completed') {
      return (
        <svg className="w-6 h-6 text-[#06D6A0]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    }
    if (status === 'in_progress') {
      return (
        <div className="w-6 h-6 rounded-full border-2 border-[#00B4D8] flex items-center justify-center">
          <div className="w-2 h-2 rounded-full bg-[#00B4D8]"></div>
        </div>
      );
    }
    return (
      <div className="w-6 h-6 rounded-full border-2 border-[#3A424D]"></div>
    );
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00B4D8] mx-auto"></div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {modules.map((module) => (
        <button
          key={module.module_id}
          onClick={() => module.is_unlocked && navigate(`/modules/${module.module_id}`)}
          disabled={!module.is_unlocked}
          className={`w-full flex items-center gap-4 p-4 rounded-xl transition-all text-left ${
            module.is_unlocked
              ? 'bg-[#2D3640] border border-[#3A424D] hover:bg-[#3A424D] hover:border-[#00B4D8]/50 cursor-pointer'
              : 'bg-[#1C2127] border border-[#3A424D] cursor-not-allowed opacity-50'
          }`}
        >
          <div className="flex-shrink-0">
            {module.is_unlocked ? (
              getStatusIcon(module.status)
            ) : (
              <svg className="w-6 h-6 text-[#6C757D]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            )}
          </div>
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="text-xs font-semibold text-[#00B4D8]">Module {module.number}</span>
              {module.status === 'completed' && (
                <span className="text-xs text-[#06D6A0] font-medium">Completed</span>
              )}
              {module.status === 'in_progress' && (
                <span className="text-xs text-[#FFB627] font-medium">In Progress</span>
              )}
            </div>
            <h3 className="text-sm font-semibold text-white truncate">{module.title}</h3>
            <p className="text-xs text-[#ADB5BD] truncate">{module.description}</p>
          </div>

          {module.is_unlocked && (
            <svg className="w-5 h-5 text-[#00B4D8] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
        </button>
      ))}
    </div>
  );
}
